export default {
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success',
};
